import { render, staticRenderFns } from "./manualList.vue?vue&type=template&id=15b04934"
import script from "./manualList.vue?vue&type=script&lang=js"
export * from "./manualList.vue?vue&type=script&lang=js"
import style0 from "./manualList.vue?vue&type=style&index=0&id=15b04934&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports